var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgA4ElectricalEnclosure(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.82 10.19A4 4 0 0058 9H19a4 4 0 00-4 4v50a4 4 0 004 4h39a4 4 0 004-4V13a4 4 0 00-1.18-2.81zM58 16.58V63H19V13h39v3.58zM40 28h-3v-7h3v7zm-7 0h-3v-7h3v7zm-7 0h-3v-7h3v7zm-3 3h31v4H23v-4zm17 11v7h-3v-7h3zm11 0h3v7h-3v-7zm-4 0v7h-3v-7h3zm-14 0v7h-3v-7h3zm-7 7h-3v-7h3v7zm-3 3h31v4H23v-4z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/A4_Electrical_enclosure.39978f42.svg";
export { SvgA4ElectricalEnclosure as ReactComponent };